<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Add a Host booking restriction to {{hspt.huis_code }}  {{hspt.hspt_nr}}</p>
    <v-form ref="addHpbr" v-model="addHpbrValid">
     
     <v-row no-gutters>
      <v-col cols="5" class="ma-2">
        <v-select v-model="hspt.hpbr_maand_van" required :items="maand_nrKeuzes" item-value="maand_nr" item-text="maand_oms" label="From month" dense :rules="maand_nrRules"></v-select>      
      </v-col>
       <v-col cols="5" class="ma-2">
        <v-select v-model="hspt.hpbr_maand_tm" required :items="maand_nrKeuzes" item-value="maand_nr" item-text="maand_oms" label="Until month" dense :rules="maand_nrRules"></v-select>      
      </v-col>
     </v-row>  

     <v-row no-gutters>
      <v-col cols="8" class="ma-2">
        <v-select v-model="hspt.hpbr_advv" required :items="advv_nrKeuzes" item-value="advv_nr" item-text="advv_oms" label="Number of days before arrival" dense></v-select>      
      </v-col>
     </v-row>  

     <v-row no-gutters>
      <v-col cols="5" class="ma-2">
        <v-select v-model="hspt.hpbr_aant_nacht" required :items="aant_nacht_nrKeuzes" item-value="aant_nacht_nr" item-text="aant_nacht_oms" label="Maximum number of nights" dense></v-select>      
      </v-col>
      <v-col cols="5" class="ma-2">
        <v-select v-model="hspt.hpbr_aant_aank" required :items="aant_aank_nrKeuzes" item-value="aant_aank_nr" item-text="aant_aank_oms" label="Maximum number of arrivals" dense></v-select>      
      </v-col>
     </v-row>  
       
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHpbr" :disabled="!addHpbrValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../../main";

export default {
  data() { 
    return {
      dialog: false,
      addHpbrValid: false,
      hspt_encrid: null,
      hspt: {},
      maand_nrKeuzes: [],
      advv_nrKeuzes: [],
      aant_nacht_nrKeuzes: [],
      aant_aank_nrKeuzes: [],
      maand_nrRules: [
          v => !!v || "A month is required"
      ]   
    }
  },
  methods: {
    open(hspt_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hspt_encrid = hspt_encrid;
      this.$axios
        .post("ares/json/ares/huis/hspt/hpbr/getHsptToAddHpbr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsptToAddHpbr"
          },
          getHsptToAddHpbr: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.getHsptToAddHpbr;
            res.data.getHsptToAddHpbr.maand_nrKeuzes.forEach(function(maand) {
               deze.maand_nrKeuzes.push(maand); 
            });
            res.data.getHsptToAddHpbr.advv_nrKeuzes.forEach(function(advv) {
               deze.advv_nrKeuzes.push(advv); 
            });
            res.data.getHsptToAddHpbr.aant_nacht_nrKeuzes.forEach(function(nacht) {
               deze.aant_nacht_nrKeuzes.push(nacht); 
            });
            res.data.getHsptToAddHpbr.aant_aank_nrKeuzes.forEach(function(aank) {
               deze.aant_aank_nrKeuzes.push(aank); 
            });
            deze.hspt_encrid = hspt_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHpbr() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hpbr/addHpbr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHpbr"
          },
          addHpbr: {
            hspt_encrid: this.hspt.hspt_encrid,
            kstp_nr: this.kstp_nr,
            hpbr_maand_van: parseInt(this.hspt.hpbr_maand_van),
            hpbr_maand_tm: parseInt(this.hspt.hpbr_maand_tm),
            hpbr_advv: parseInt(this.hspt.hpbr_advv),
            hpbr_aant_nacht: parseInt(this.hspt.hpbr_aant_nacht),
            hpbr_aant_aank: parseInt(this.hspt.hpbr_aant_aank)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            //  if (res.data.addHpbr.color == "success") {
            //     // this.$router.reload('/huis/onHuis/' + res.data.addHpbr.huis_encrid);  
            //     bus.$emit("closeDialog", "reload");
            //  }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHpbr.text,
              color: res.data.addHpbr.color
            }); 
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    }
  }
}
</script>

